import React from "react";
import { useHistory } from "react-router-dom";
import { ProtectedRoute } from "../../../Auth/ProtectedRoute/ProtectedRoute ";
import NewInspectionNative from "./NewInspection.native";

const NewInspectionContainer = () => {
  const history = useHistory();

  const goToNewInspectionPlate = () => {
    history.push('/new-inspection/profile');
  }

  return (
    <ProtectedRoute>
      <NewInspectionNative
        goToNewInspectionPlate={goToNewInspectionPlate}
      />
    </ProtectedRoute>
  );
};

export default NewInspectionContainer;
